import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NewsLetterService } from 'src/app/services/news-letter.service';
@Component({
  selector: 'app-news-letter',
  templateUrl: './news-letter.component.html',
  styleUrls: ['./news-letter.component.scss']
})
export class NewsLetterComponent implements OnInit {
  newsLetterSignUp=new FormGroup({
    email:new FormControl()
  });
  newsLetterMesssage='';
  alreadyExist='';
  errormsg='';
  constructor(private fb: FormBuilder,private newsLetterService:NewsLetterService){

  }
  ngOnInit(): void {
    this.newsLetterSignUp = this.fb.group({
      email:new FormControl('',Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"))
  })
  
  }

  onSubmit(){
    if(this.newsLetterSignUp.valid){
      this.newsLetterService.newsLetter(this.newsLetterSignUp.value).subscribe(response=>{
        if(response.status==200)this.newsLetterMesssage=response.message
        if(response.status==500)this.alreadyExist=response.message
        setTimeout(() => {
          this.newsLetterMesssage=''
          this.errormsg=''
        }, 10000);
      })
    }
    else{
      this.errormsg="newsletter.valid_email"
    }
  
    
}
resetMessage(){
  this.alreadyExist='';
  this.newsLetterMesssage='';
  this.errormsg='';
}
}
